import { useEffect, useRef, useState } from "react";

import * as Material from "@mui/material";

import ConfigLoader from "../../components/ConfigLoader";

import Popper from "@components/Popper";

import './styles.css'

import api from '@helpers/api'

import { AddRounded, AllInclusiveRounded, CachedRounded, CopyAllRounded, CreditCardRounded, DeleteRounded, MoreVertRounded, PixRounded, RedoRounded, RotateRightRounded, SettingsRounded } from "@mui/icons-material";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";

import Parser from '@helpers/parser'
import ConfigPlanModal from "@components/_modals/Billing/ManagePlanModal";

import { Button, Text } from "@fragments";

export default function Pricing({ info }) {
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const [plans, setPlans] = useState([])

    const { loading: communityLoading, community, loadCommunities } = useCommunity();

    const REF_config = useRef()
    const REF_configPlanModal = useRef()

    const popperRef = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    async function handleLoad() {
        setLoading(true)

        try {
            const currentCommunity = community.getBySlug(slug);
            if (currentCommunity?.id) {
                const { data } = await api.get(`community/${currentCommunity.id}/plan`)
                setPlans(data)
            }
        } catch (e) {
            console.log(e)
        }

        setLoading(false)
    }

    function handleConfigurePlan(id) {
        REF_configPlanModal.current.open({
            id,
            community: community.getBySlug(slug).id
        }, async function (result) {
            console.log(result)
            handleLoad()
            await loadCommunities()
        })
    }

    function handleDeletePlan(id) {
        window.openConfirm({
            title: "Deletar plano",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este plano?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: handleExecuteDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter plano",
                    variant: "text",
                },
            ],
        });

        async function handleExecuteDelete() {
            try {
                const data = await api.delete('community/plan/' + id)
                if (data.status === 204) {
                    window.setSnackbar('Plano deletado com sucesso')
                    await handleLoad()
                }
            } catch (e) {
                window.setSnackbar('Ocorreu um erro ao deletar o plano, verifique se você possui permissão para realizar esta ação')
                console.log(e)
            }
        }
    }

    function handleOpenPlanOptions(event, planId) {
        const options = [
            {
                id: 'configure',
                label: 'Configurar',
                icon: <SettingsRounded fontSize="small" />,
                onClick: async () => {
                    handleConfigurePlan(planId);
                    popperRef.current.close();
                }
            },
            {
                id: 'delete',
                label: 'Excluir plano',
                icon: <DeleteRounded fontSize="small" />,
                variant: 'danger',
                onClick: async () => {
                    handleDeletePlan(planId);
                    popperRef.current.close();
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }

    function handleCopy(plan) {
        const link = `https://pay.ginastee.com/${community.getBySlug(slug).checkout}?plan=${plan}`
        navigator.clipboard.writeText(link).then(() => {
            window.setSnackbar("Link copiado");
        }).catch(err => {
            console.error('Erro ao copiar:', err);
            window.setSnackbar("Erro ao copiar o link");
        });
    }


    function PlanRow({ id, label, interval, price, installments, methods, installments_list, autorenew }) {

        return (
            <div className="plan-config-box mb-1">
                <div className="plan-config-row pt-1 px-1">
                    <div>
                        <span className="interval-badge plan-row-btn" style={{ paddingRight: '11px' }}>
                            {
                                interval === 'lifetime' ? <AllInclusiveRounded fontSize="small" /> : !autorenew ? <CachedRounded fontSize="small" /> : <RedoRounded fontSize="small" />
                            }
                            <small>{Parser.interval.adjective(interval)}</small>
                        </span>
                    </div>
                    <h5 style={{ flex: 1 }} className="bold">{label}</h5>
                    <span className="plan-row-btn"
                        onClick={() => handleCopy(id)}
                    >
                        <small>Link do checkout</small>
                        <CopyAllRounded fontSize="small" />
                    </span>
                    <span
                        className="plan-row-btn"
                        onClick={() => handleConfigurePlan(id)}>
                        <SettingsRounded fontSize="small" />
                    </span>
                    <span
                        className="plan-row-btn"
                        onClick={(event) => handleOpenPlanOptions(event, id)}
                    >
                        <MoreVertRounded fontSize="small" />
                    </span>
                </div>
                <Material.Divider flexItem className="mt-1 mb-2" />
                <div className="plan-config-row px-2 pb-2">
                    <span style={{ flex: 1 }}>
                        <small className="bold">Preço: </small>
                        R${Parser.price.brl(price)} {installments > 1 && `ou ${installments}x de R$${Parser.price.brl(installments_list[installments - 1] / installments)}`}
                    </span>
                    <div className="plan-config-row methods-row">
                        <div className={"plan-config-row method " + (!methods.credit.enabled && 'disabled')}>
                            <CreditCardRounded fontSize="small" />
                            <small>Crédito</small>
                        </div>
                        <Material.Divider flexItem orientation="vertical" />
                        <div className={"plan-config-row method " + (!methods.pix.enabled && 'disabled')}>
                            <PixRounded fontSize="small" />
                            <small>PIX</small>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function CreatePlanButton() {
        return (
            <Button
                onClick={() => handleConfigurePlan()}
                endIcon={< AddRounded />}
                text="Criar plano"
            />
        )
    }


    return (
        <div className="config-page config-general-community" key={loading}>
            <h2>Preços disponíveis na sua comunidade</h2>

            {(loading || communityLoading) ? <ConfigLoader /> : (
                <div className="mt-4" key={Math.random()}>
                    <Text.h3
                        grow
                        left={<RotateRightRounded />}
                        right={<CreatePlanButton />}
                        value="Planos configurados"
                        className="mb-2"
                    />

                    {plans?.map((plan, key) => (
                        <PlanRow
                            key={key}
                            {...plan}
                        />
                    ))}
                </div>
            )}

            <Popper controlRef={popperRef} />

            <ConfigPlanModal modalRef={REF_configPlanModal} />
        </div >
    )
}